import script from "./Scorecard.vue?vue&type=script&lang=ts&setup=true"
export * from "./Scorecard.vue?vue&type=script&lang=ts&setup=true"

import "./Scorecard.vue?vue&type=style&index=0&id=41dbba76&lang=sass&scoped=true"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41dbba76"]])

export default __exports__